import moment from 'moment';
import {LOCAL_STORAGE_SEARCHED_CAPTATIONS_POINTS, LOCAL_STORAGE_SEARCHED_EFFLUENTS_POINTS} from '../../helpers/local_storage_constants';

const state = {
    searchedCaptationPoints: [],
    searchedEffluentPoints: [],
};

const mutations = {
    setSearchedCaptationPoints(state, data){
        state.searchedCaptationPoints = data ? data : [];
    },
    setSearchedEffluentPoints(state, data){
        state.searchedEffluentPoints = data ? data : [];
    },
};

const actions = {
    async saveInCacheSearchedBasinsPoints ( {commit} , payload){
        const {searchedBasinPoint, basinId} = payload;
        const key = basinId === 16 ? LOCAL_STORAGE_SEARCHED_CAPTATIONS_POINTS : LOCAL_STORAGE_SEARCHED_EFFLUENTS_POINTS;
        let searchedBasinsPoints;
    
        try{
          searchedBasinsPoints =  JSON.parse(localStorage.getItem(key));
          searchedBasinsPoints = searchedBasinsPoints.filter((basinPoint)=> basinPoint.customerid)
        }catch(error){
          searchedBasinsPoints = [];
        }
    
        if(!searchedBasinsPoints){
          searchedBasinsPoints = [];
        }
    
        if(searchedBasinPoint){
          const findCaptationPointIndex = searchedBasinsPoints.findIndex((captationPoint) => captationPoint.locationid === searchedBasinPoint.locationid)
          const newSearchedCaptationPoint = {...searchedBasinPoint, lastSearch: moment().format('YYYY-MM-DDTHH:mm:ss')}
          if(findCaptationPointIndex != -1){
            searchedBasinsPoints[findCaptationPointIndex] = newSearchedCaptationPoint;
          }else{
            searchedBasinsPoints.push(newSearchedCaptationPoint);
          }
    
          searchedBasinsPoints = searchedBasinsPoints.sort((a,b) => moment(a.lastSearch).isAfter(moment(b.lastSearch)) ? -1 : 1);
          if(searchedBasinsPoints.length > 3){
            searchedBasinsPoints = searchedBasinsPoints.slice(0, 3);
          }
    
          localStorage.setItem(key, JSON.stringify(searchedBasinsPoints));
        }

        if(basinId === 16){
            commit('setSearchedCaptationPoints', searchedBasinsPoints);
        }else{
            commit('setSearchedEffluentPoints', searchedBasinsPoints);
        }
    
    },
};

const getters = {
    searchedCaptationPoints: (state) => state.searchedCaptationPoints,
    searchedEffluentPoints: (state) => state.searchedEffluentPoints,
};
export default {
  state,
  mutations,
  actions,
  getters
}
